export default __webpack_public_path__ + "static/shaken-cf9bda6c4c5e860a8fcdb1f0f5b00af3.svg";